const isProduction = process.env.NODE_ENV === "production";

const config = {
  // Legacy backend (system_tef_be) — still used by the Contact Us inquiry form.
  apiUrl: "https://systembe.tef.co.id/public/",

  // compro_tef_be — Blog, Factory Tour (public + admin), Career admin CRUD.
  factoryTourApiUrl: isProduction
    ? "https://compro-tef-be.tef.co.id/public/api/"
    : "http://localhost/COMPRO TEF/compro_tef_be/public/api/",
  blogStorageUrl: isProduction
    ? "https://compro-tef-be.tef.co.id/public/storage/"
    : "http://localhost/COMPRO TEF/compro_tef_be/public/storage/",
};

export default config;
